<script setup>
import AppLayout from "@/Layouts/AppLayout.vue";
import EditUserInformation from "@/Components/Admin/User/EditUserInformation.vue";
import SecondaryButton from "@/Components/SecondaryButton.vue";
import FormSection from "@/Components/FormSection.vue";
import {ref, computed} from "vue";
import {usePage} from "@inertiajs/inertia-vue3";

const props = defineProps({
  user: Object,
  vendors: Array,
  companies: Array,
  permissions: Object,
  userTypes: Object,
  userTypePermissionMap: Object,
});

const userType = ref(props.user.employeeType || '');

const updateUserType = (updatedUserType) => {
  userType.value = updatedUserType;
}

const page = usePage()
const isProduction = computed(() => page.props.environment === 'production')

const filteredPermissions = computed(() => {
  if (!isProduction.value) return props.permissions

  const out = { ...props.permissions }

  if (out.style_generator !== undefined) {
    delete out.style_generator
  }

  if (Array.isArray(out)) {
    return out.filter(p => p?.key !== 'style_generator' && p?.name !== 'style_generator')
  }

  return out
})
</script>

<template>
  <AppLayout title="Edit User">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        <span v-if="user.employeeID">Edit</span><span v-else>Create</span> User: <b v-text="user.firstname"></b>
        <template v-if="user.lastname">
          &nbsp;<b v-if="user.lastname" v-text="user.lastname"></b>
        </template>
      </h2>
    </template>

    <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
      <FormSection>
        <template #title>
          <a :href="route('admin.users.active')">
            <SecondaryButton>Back</SecondaryButton>
          </a>
        </template>
        <template #form>
          <img :src="user.profile_photo_url" :alt="user.firstname" class="rounded-full h-20 w-20 object-cover">
        </template>
      </FormSection>
      <EditUserInformation :vendors="vendors" :companies="companies" :user-types="userTypes"
                           :update-selected-user-type="updateUserType"
                           :user-type-permission-map="userTypePermissionMap"
                           :permissions="filteredPermissions"/>
    </div>
  </AppLayout>
</template>
